'use strict';

const Mn = require('backbone.marionette');
const SidebarNavListView = require('common/ui/view/sidebar/nav');
const Template = require('balus/ui/template/body/project/toolbar/index.hbs');
const FullScreenButtonTemplate = require('balus/ui/template/body/project/toolbar/full-screen-button.hbs');
const GanttEditButtonTemplate = require('balus/ui/template/body/project/toolbar/gantt-edit-button.hbs');
const ProcessPermission = require('process/domain/entity/permission');

const FullScreenButtonView = Mn.View.extend({
    tagName: 'span',
    template: FullScreenButtonTemplate,
    isFullScreen: false,
    ui: {
        enterFullScreenButton: '.enter-full-screen',
        exitFullScreenButton: '.exit-full-screen',
    },
    events: {
        'click @ui.enterFullScreenButton': 'enterFullScreen',
        'click @ui.exitFullScreenButton': 'exitFullScreen'
    },

    templateContext: function() {
        return {
            isFullScreen: this.getOption('isFullScreen')
        }
    },

    enterFullScreen: function() {
        this.isFullScreen = true;
        this.render();
        this.triggerMethod('enter:full:screen');
    },

    exitFullScreen: function() {
        this.isFullScreen = false;
        this.render();
        this.triggerMethod('exit:full:screen');
    }
});

const GanttEditButtonView = Mn.View.extend({
    tagName: 'span',
    template: GanttEditButtonTemplate,
    isGanttEditMode: false,
    templateContext: function() {
        return {
            isGanttEditMode: this.getOption('isGanttEditMode')
        };
    },
    ui: {
        ganttEditButton: '.gantt-edit',
        ganttDoneButton: '.gantt-done'
    },
    events: {
        'click @ui.ganttEditButton': 'startGanttEditMode',
        'click @ui.ganttDoneButton': 'endGanttEditMode'
    },

    startGanttEditMode: function() {
        this.isGanttEditMode = true;
        this.render();
        this.triggerMethod('gantt:edit');
    },

    endGanttEditMode: function() {
        this.isGanttEditMode = false;
        this.render();
        this.triggerMethod('gantt:done');
    }
});

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        nav: '.sidebar-nav',
        fullScreen: '.full-screen',
        gantt: '.gantt-edit'
    },
    childViewTriggers: {
        'enter:full:screen': 'enter:full:screen',
        'exit:full:screen': 'exit:full:screen',
        'gantt:edit': 'gantt:edit',
        'gantt:done': 'gantt:done'
    },
    ui: {
        ganttPrintButton: '.print-gantt'
    },
    events: {
        'click @ui.ganttPrintButton': 'printGantt'
    },

    onRender: function() {
        const context = this.getOption('context');

        this.showChildView('fullScreen', new FullScreenButtonView());

        if(context.getProjectRole().getPermission(
            ProcessPermission.ActionCreatePermission
        ).isPermitted(context)) {
            this.showChildView('gantt', new GanttEditButtonView());
        }
    },

    renderNav: function(navs) {
        this.showChildView('nav', new SidebarNavListView({
            collection: navs,
            horizontal: true
        }));
    },

    printGantt: function() {
        this.triggerMethod('close:sidebar');

        setTimeout(() => {
            window.print();
        }, 300);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/toolbar/index.js